import * as es from './locale/es.json'
import * as en from './locale/en.json'
import get from 'lodash.get'
import { LanguageISO6391 } from 'ai-constants'

export const t = (
  word: string,
  variables?: Record<string, any>,
  lang: LanguageISO6391 = 'es',
): string => {
  let translation = get(lang === 'es' ? es : en, word) || word

  if (typeof translation !== 'string') {
    return word
  }

  if (variables) {
    const normalizedVariables = Object.fromEntries(
      Object.entries(variables).map(([key, value]) => [
        key.toLowerCase(),
        value,
      ]),
    )

    translation = translation.replace(/{([^}]+)}/g, (match, key) => {
      const variableKey = key.toLowerCase().trim()

      if (variableKey in normalizedVariables) {
        return String(normalizedVariables[variableKey])
      }
      return match
    })
  }

  return translation
}
